import { hexToARGB } from '@tornado-rdk/theme';

export const DEFAULT_CONTAINER_SCALE = 0.8;

export const units = {
  PX: 0,
  PERCENTAGE: 1,
  LINES: 2,
};

export const writingMode = {
  HORIZONTAL_TOP_TO_BOTTOM: 'horizontal-tb',
  VERTICAL_LEFT_TO_RIGHT: 'vertical-lr',
  VERTICAL_RIGHT_TO_LEFT: 'vertical-rl',
};

export const DEFAULT_REGION = 'default';

export const DEFAULT_BACKGROUND_COLOR = hexToARGB('#000000', 0);
